import { createContext } from 'react';

/** A resolved theme — exactly what `body[data-theme]` carries. */
export type ThemeMode = 'light' | 'dark';

/** A brand's configured mode (`Settings -> Branding`). `system` defers to
 * `prefers-color-scheme`. */
export type ThemePreference = ThemeMode | 'system';

export interface ThemeContextValue {
  /** The theme actually in effect right now. */
  readonly theme: ThemeMode;
  /**
   * Apply the resolved brand's "light/dark default". There is no user
   * override anywhere in the app — the brand is authoritative, and this is
   * called every time one resolves (`useBrand` pre-auth, `useMyBrand` once
   * signed in), so the app always reflects whichever brand last resolved.
   */
  readonly applyBrand: (mode: ThemePreference) => void;
}

/** Media query the `system` mode listens to. */
export const DARK_SCHEME_QUERY = '(prefers-color-scheme: dark)';

export const ThemeContext = createContext<ThemeContextValue | null>(null);
